import { useContext } from "react";
import { GelScreenDetectorContext } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";

const PageHeader = ({ children }: { children: React.ReactNode }) => {
    const { screen, isXsScreen } = useContext(GelScreenDetectorContext) as GelScreenDetectorContext;

    const {
        global: { sizeBaseX5, sizeBaseX10, sizeBaseX15, themeColorBackgroundLight },
    } = getGelTokens();

    // Calculate padding based on screen size
    const padding = isXsScreen(screen) 
        ? `${sizeBaseX15}px ${sizeBaseX5}px` 
        : `${sizeBaseX15}px ${sizeBaseX10}px`;

    return (
        <div style={{ padding, backgroundColor: themeColorBackgroundLight }}>
            {children}
        </div>
    );
};

export default PageHeader;
